import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field, formValueSelector, change } from "redux-form";
import renderHTML from 'react-render-html';
import { FormattedDate } from "react-intl";
import { Masks } from "../constants/enums";
import * as agent from "../agent";
import SecurityNKBI from "./SecurityNKBI";
import SecurityCronos from "./SecurityCronos";
import SecurityKAD from "./SecurityKAD";
import Bankrupt from "./Bankrupt";
import OuterLink from './OuterLink';
import { CLIENT_LOADED } from "../constants/actionTypes";
import { MaterialTextField, MaterialMaskedTextField } from "./MaterialInput";
import { required } from "../utility";
import MaterialAddressSuggest from "./MaterialAddressSuggest";
import SubmitButton from './SubmitButton';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';

const loanDraftForm = ({ resetFSSP, resetTerror, resetFNP, isDraft, onSubmitDraft, handleSubmit, carId }) => (
    <form onSubmit={ handleSubmit(data => onSubmitDraft(carId, data)) }>
        <Grid container justify="center" spacing={16}>
            <Grid item className="common-column common-form">
                <Field component={MaterialTextField}
                       onChange={() => { resetFSSP(); resetTerror() }}
                       validate={required}
                       disabled={!isDraft}
                       name="secondname"
                       label="Фамилия" />
                <Field component={MaterialTextField}
                       onChange={() => { resetFSSP(); resetTerror() }}
                       name="firstname"
                       validate={required}
                       disabled={!isDraft}
                       label="Имя"/>
                <Field name="thirdname"
                       component={MaterialTextField}
                       validate={required}
                       disabled={!isDraft}
                       onChange={resetFSSP}
                       label="Отчество" />
                <Field name="birthDate"
                       component={MaterialMaskedTextField}
                       validate={required}
                       disabled={!isDraft}
                       onChange={resetFSSP}
                       mask={Masks.date}
                       label="Дата рождения" />
                <Field component={MaterialMaskedTextField}
                       validate={required}
                       disabled={!isDraft}
                       onChange={resetFNP}
                       mask={Masks.vin}
                       name="vin"
                       label="VIN номер"/>
            </Grid>
            <Grid item className="common-column common-form">
                <Field name="passportSerie"
                       component={MaterialMaskedTextField}
                       validate={required}
                       disabled={!isDraft}
                       mask={Masks.passportSerie}
                       label="Серия паспорта" />
                <Field name="passportNumber"
                       component={MaterialMaskedTextField}
                       validate={required}
                       disabled={!isDraft}
                       mask={Masks.passportNumber}
                       label="Номер паспорта" />
                <Field name="passportDate"
                       component={MaterialMaskedTextField}
                       validate={required}
                       disabled={!isDraft}
                       mask={Masks.date}
                       label="Дата выдачи" />
                <Field component={MaterialAddressSuggest}
                       name="address"
                       disabled={!isDraft}
                       label="Адрес регистрации" />
            </Grid>
        </Grid>
        {isDraft && <SubmitButton label="Отправить в СБ" />}
    </form>
);

const LoanDraftForm = connect(
    (state, props) => {
        const { carId, client } = state.client;
        const { status, contractStatus } = props;
        const car = client.cars.find(c => c._id === carId);
        const { firstname,
                secondname,
                thirdname,
                birthDate: initialBirthDate,
                passport: {serie, number, date} = { },
                address: initialAddress } = client;
        const { clientDetails = {}, carDetails = {} } = car.contract || {};
        const initialValues = Object.assign({},
            {
                firstname,
                secondname,
                thirdname,
                birthDate: initialBirthDate,
                passportSerie: serie,
                passportNumber: number,
                passportDate: date,
                address: initialAddress,
                vin: car.vin
            },
            ["ACTIVE", "TRADE", "CLOSED"].includes(status) || (status === "APPROVED" && ["SECOND", "THIRD", "FOURTH"].includes(contractStatus)) ?
            {
                firstname: clientDetails.firstname,
                secondname: clientDetails.lastname,
                thirdname: clientDetails.patronymic,
                birthDate: clientDetails.birthDate,
                passportSerie: clientDetails.passportSerie,
                passportNumber: clientDetails.passportNumber,
                passportDate: clientDetails.passportDate,
                address: clientDetails.addressRegister
            } : {},
            ["ACTIVE", "TRADE", "CLOSED"].includes(status) || (status === "APPROVED" && ["THIRD", "FOURTH"].includes(contractStatus)) ? { vin: carDetails.vin } : {}
        );

        return { carId, initialValues };
    },
    dispatch => ({
        onSubmitDraft: (carId, data) =>
            agent.Clients.submitDraft(carId, data)
            .then(client => dispatch({type: CLIENT_LOADED, payload: client})),
    })
)(reduxForm({ form: "loan-draft-form" })(loanDraftForm));

class LoanDraft extends React.Component {

    state = {
        captcha: "",
        fsspStatus: "INACTIVE",
        fsspResult: [],
        fsspError: "",
        fnpStatus: "INACTIVE",
        fnpResult: [],
        fnpImage: "",
        fnpSessionID: "",
        fnpError: "",
        terrorStatus: "INACTIVE",
        terrorResult: [],
        terrorError: ""
    };

    componentDidMount() {
        this.fetchCaptcha();
    };

    fetchCaptcha = () => {
        agent.src.captcha()
            .then(json => this.setState({ fnpImage: json.image, fnpSessionID: json.sessionID }))
            .catch(e => alert(e));
    };
    enterCaptcha = e => this.setState({ captcha: e.target.value });

    resetTerror = () => this.setState({ terrorStatus: "INACTIVE" });
    resetFNP = () => this.setState({ fnpStatus: "INACTIVE" });
    resetFSSP = () => this.setState({ fsspStatus: "INACTIVE" });

    fetchFSSP = e => {
        e.preventDefault();
        this.setState({ fsspStatus: "LOADING" })
        const { secondname, firstname, thirdname, birthDate } = this.props;
        agent.Clients.fsspinfo(firstname, secondname, thirdname, birthDate)
        .then(res => {
            this.setState({ fsspStatus: "SUCCESS", fsspResult: res })
        })
        .catch(err => {
            this.setState({ fsspStatus: "REJECTED", fsspResult: [], fsspError: err.message })
        })
    };
    fetchTerror = e => {
        e.preventDefault();
        this.setState({ terrorStatus: "LOADING" })
        const { secondname, firstname } = this.props;
        agent.Clients.checkTerrorist(`${secondname.trim()} ${firstname.trim()}`)
            .then(res => this.setState({ terrorStatus: "SUCCESS", terrorResult: res }))
            .catch(err => this.setState({ terrorStatus: "REJECTED", terrorError: err.message }));
    };
    fetchFNP = e => {
        e.preventDefault();
        this.setState({ fnpStatus: "LOADING" })
        const { vin, dispatch } = this.props;
        const { fnpSessionID = "", captcha } = this.state;
        agent.Clients.FNPRequset(vin, fnpSessionID, { captcha })
            .then(res => {
                if (res.status !== 403) {
                    this.setState({ fnpStatus: "SUCCESS", fnpResult: res });
                    dispatch(change("loan-draft-form", "captcha", ""));
                }
                this.fetchCaptcha();
            })
            .catch(err => this.setState({ fnpStatus: "REJECTED", fnpError: err.message }))
    };

    render() {
        const { secondname = "",
                firstname = "",
                thirdname = "",
                birthDate,
                address,
                passportDate,
                passportSerie,
                passportNumber,
                vin,
                carId,
                clientId,
                isNKBIRequested,
                isNKBIFetched,
                nkbiReportLink,
                nkbiRequestDate,
                nkbiRequestId,
                nkbi,
                isCronosRequested,
                isCronosFetched,
                cronosReportLink,
                cronosRequestDate,
                cronosRequestId,
                cronos,
                status,
                contractStatus } = this.props;
        const { captcha, fsspStatus, fsspResult, fsspError, fnpStatus, fnpResult: {data = []} = {}, fnpImage, fnpError, terrorStatus, terrorResult: {Html}, terrorError } = this.state;

        return (
            <Grid container justify="flex-start" spacing={24}>
                <Grid item >
                    <Paper className="common-paper">
                        <LoanDraftForm resetTerror={this.resetTerror}
                                       resetFSSP={this.resetFSSP}
                                       resetFNP={this.resetFNP}
                                       status={status}
                                       contractStatus={contractStatus}
                                       isDraft={status === "DRAFT"}/>
                    </Paper>
                </Grid>
                <Grid item xs>
                    <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="h5">Проверка по базе ГИБДД</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <OuterLink href={`https://гибдд.рф/check/auto/#${vin}`} label={"Проверка на сайте"}/>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                    <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="h5">Проверка по базе ФССП</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <Grid container direction="column" justify="flex-start" alignItems="flex-start" spacing={16}>
                                { ({
                                    "INACTIVE": (<Grid item ><Typography paragraph >Проверка не проводилась</Typography></Grid>),
                                    "LOADING": (<Grid item >
                                                    <Typography paragraph >Поиск информации. Ожидайте...</Typography>
                                                    <CircularProgress />
                                                </Grid>),
                                    "SUCCESS": (<Grid item >
                                                    {fsspResult.length > 0 ?
                                                        <Table padding="dense">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell >Должник</TableCell>
                                                                    <TableCell>ИП</TableCell>
                                                                    <TableCell>Дата, причина окончания</TableCell>
                                                                    <TableCell>Предмет исполнения</TableCell>
                                                                    <TableCell>Отдел судебных приставов</TableCell>
                                                                    <TableCell>Пристав-исполнитель</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                { fsspResult.map( ({ name, details, ip_end, subject, department, bailiff = "" }, i) => {
                                                                    return  (
                                                                        <TableRow key={i}>
                                                                            <TableCell >{name}</TableCell>
                                                                            <TableCell>{details}</TableCell>
                                                                            <TableCell>{ip_end}</TableCell>
                                                                            <TableCell>{subject}</TableCell>
                                                                            <TableCell>{department}</TableCell>
                                                                            <TableCell>{bailiff.replace(/<.+?>/g,'\n')}</TableCell>
                                                                        </TableRow>
                                                                    );
                                                                } )}
                                                            </TableBody>
                                                        </Table> : <Typography paragraph >Данные отсутствуют</Typography>
                                                    }
                                                </Grid>),
                                    "REJECTED":  (<Grid item ><Typography paragraph >Возникла ошибка: {fsspError}</Typography></Grid>)
                                })[fsspStatus] }
                                <Grid item>
                                    <Button type="submit"
                                            onClick={this.fetchFSSP}
                                            size="large"
                                            color="primary"
                                            variant="contained"> Запрос информации </Button>
                                </Grid>
                            </Grid>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                    <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="h5">Проверка по базе ПОД / ФТ</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <Grid container direction="column" justify="flex-start" alignItems="flex-start" spacing={16}>
                            { ({
                                "INACTIVE": (<Grid item ><Typography paragraph >Проверка не проводилась</Typography></Grid>),
                                "LOADING": (<Grid item >
                                                <Typography paragraph >Поиск информации. Ожидайте...</Typography>
                                                <CircularProgress />
                                            </Grid>),
                                "SUCCESS": (<Grid item >
                                                <Typography paragraph >Результат поиска по запросу '{secondname} {firstname}'</Typography>
                                                { Html && renderHTML(Html) }
                                            </Grid>),
                                "REJECTED":  (<Grid item ><Typography paragraph >Возникла ошибка: {terrorError}</Typography></Grid>)
                            })[terrorStatus] }
                                <Grid item>
                                    <Button type="submit"
                                            onClick={this.fetchTerror}
                                            disabled={firstname.length === 0 || secondname.length === 0}
                                            size="large"
                                            color="primary"
                                            variant="contained"> Запрос информации </Button>
                                </Grid>
                            </Grid>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                    <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="h5">Проверка по базе ФНП</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <Grid container direction="column" justify="flex-start" alignItems="flex-start" spacing={16}>
                                <Grid item >
                                    {fnpImage.length > 0 ? <img src={fnpImage} onClick={this.fetchCaptcha} alt="captcha" /> : <Typography paragraph>Загрузка изображения...</Typography>}
                                </Grid>
                                <Grid item className="wide-column">
                                    <TextField fullWidth
                                               variant="outlined"
                                               margin="dense"
                                               label="Введите символы с картинки"
                                               onChange={this.enterCaptcha} />
                                </Grid>
                            { ({
                                "INACTIVE": (<Grid item ><Typography paragraph >Проверка не проводилась</Typography></Grid>),
                                "LOADING": (<Grid item >
                                                <Typography paragraph >Поиск информации. Ожидайте...</Typography>
                                                <CircularProgress />
                                            </Grid>),
                                "SUCCESS": (<Grid item >
                                                {data.length > 0 ?
                                                    <Table >
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell>Дата</TableCell>
                                                                <TableCell>Номер уведомления</TableCell>
                                                                <TableCell>История</TableCell>
                                                                <TableCell>Имущество</TableCell>
                                                                <TableCell>Залогодатель</TableCell>
                                                                <TableCell>Залогодержатель</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            { data.map(({regDate, id, history, link, properties, pledgors, pledgees}, i) =>
                                                                <TableRow key={i}>
                                                                    <TableCell>
                                                                        <FormattedDate value={new Date(regDate)}
                                                                                       day="numeric"
                                                                                       month="numeric"
                                                                                       year="numeric" />
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {id}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {history.map(({regDate, type, link}, j) => {
                                                                            return (
                                                                                <React.Fragment>
                                                                                    <FormattedDate value={new Date(regDate)}
                                                                                                   day="numeric"
                                                                                                   month="numeric"
                                                                                                   year="numeric" />
                                                                                    :
                                                                                    {{"Exclusion": " Исключение", "Creation": " Возникновение"}[type]}
                                                                                    <br />
                                                                                </React.Fragment>
                                                                            )
                                                                        })}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {properties.map(({ vehicleProperty: {vin} = {} }) => `VIN: ${vin}`).join("\n")}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {pledgors.map(({ privatePerson: {name, birthday} = {} }) => `${name} (${(new Date(birthday)).toLocaleDateString("ru-RU")})`).join("\n")}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {pledgees.map(({ organization: {name} = {}}) => `${name}`).join("\n")}
                                                                    </TableCell>
                                                                </TableRow> )}
                                                        </TableBody>
                                                    </Table> : <Typography paragraph>Данные отсутствуют</Typography>}
                                            </Grid>),
                                "REJECTED":  (<Grid item ><Typography paragraph >Возникла ошибка: {fnpError}</Typography></Grid>)
                            })[fnpStatus] }
                                <Grid item>
                                    <Button type="submit"
                                            disabled={fnpStatus === "LOADING" || (vin||"").replace("_","").length < 17 || captcha.length < 5}
                                            onClick={this.fetchFNP}
                                            size="large"
                                            color="primary"
                                            variant="contained"> Запрос информации </Button>
                                </Grid>
                            </Grid>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                    <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="h5">НБКИ-отчет для ФЛ</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <SecurityNKBI isNKBIRequested={isNKBIRequested}
                                          isNKBIFetched={isNKBIFetched}
                                          nkbiReportLink={nkbiReportLink}
                                          nkbiRequestDate={nkbiRequestDate}
                                          nkbiRequestId={nkbiRequestId}
                                          nkbi={nkbi}
                                          hasContract={false}
                                          clientDetails={({ lastname: secondname, firstname, patronymic: thirdname, birthDate, passportDate, passportSerie, passportNumber })}
                                          clientId={clientId}
                                          carId={carId} />
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                    <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="h5">Отчет СБ CRONOS</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <SecurityCronos isCronosRequested={isCronosRequested}
                                            isCronosFetched={isCronosFetched}
                                            cronosReportLink={cronosReportLink}
                                            cronosRequestDate={cronosRequestDate}
                                            cronosRequestId={cronosRequestId}
                                            cronos={cronos}
                                            hasContract={false}
                                            clientDetails={({ lastname: secondname, firstname, patronymic: thirdname, birthDate, address, passportSerie, passportNumber })}
                                            clientId={clientId}
                                            carId={carId} />
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                    <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="h5">Проверка банкротства</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <Bankrupt firstname={firstname} lastname={secondname} />
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                    <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="h5">Проверка по КАД</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <SecurityKAD firstname={firstname} lastname={secondname} patronymic={thirdname}/>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = state => {
    const secondname = formValueSelector("loan-draft-form")(state, "secondname");
    const firstname = formValueSelector("loan-draft-form")(state, "firstname");
    const thirdname = formValueSelector("loan-draft-form")(state, "thirdname");
    const birthDate = formValueSelector("loan-draft-form")(state, "birthDate");
    const address = formValueSelector("loan-draft-form")(state, "address");
    const passportDate = formValueSelector("loan-draft-form")(state, "passportDate");
    const passportSerie = formValueSelector("loan-draft-form")(state, "passportSerie");
    const passportNumber = formValueSelector("loan-draft-form")(state, "passportNumber");
    const vin = formValueSelector("loan-draft-form")(state, "vin");
    return {
        firstname,
        secondname,
        thirdname,
        birthDate,
        address,
        passportDate,
        passportSerie,
        passportNumber,
        vin
    };
}

export default connect(mapStateToProps, null)(LoanDraft);



// WEBPACK FOOTER //
// ./src/components/LoanDraft.js